function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "logo_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M0 288.424h966.94V0H0z"
})), React.createElement("clipPath", {
  id: "logo_svg__b",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M180.951 238.434h160.641V69.368H180.951z"
})), React.createElement("clipPath", {
  id: "logo_svg__c",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M364.342 288.424h27.241V73.58h-27.241z"
})), React.createElement("clipPath", {
  id: "logo_svg__d",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M424.72 288.424h27.242V73.58H424.72z"
})), React.createElement("clipPath", {
  id: "logo_svg__e",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M474.711 238.434h158.395V69.368H474.711z"
})), React.createElement("clipPath", {
  id: "logo_svg__f",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M646.78 269.046h156.99V0H646.78z"
})), React.createElement("clipPath", {
  id: "logo_svg__g",
  clipPathUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M808.546 238.434H966.94V69.368H808.546z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#logo_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 384.565)"
}, React.createElement("g", {
  clipPath: "url(#logo_svg__b)"
}, React.createElement("path", {
  d: "M313.789 151.654v3.09c0 37.351-21.344 60.1-52.517 60.1-30.893 0-52.518-21.344-52.518-60.1v-3.09c0-36.51 19.379-57.854 52.518-57.854 33.42 0 52.517 21.344 52.517 57.854m-132.838-.562v3.651c0 17.974 3.65 32.578 10.39 45.497 14.043 24.714 39.038 38.194 69.93 38.194 15.728 0 29.489-3.37 41.565-10.11 24.434-13.199 38.756-38.194 38.756-73.58v-3.652c0-17.412-3.37-31.735-9.83-44.09-13.48-24.435-37.632-37.635-70.49-37.635-51.113 0-80.321 30.051-80.321 81.725",
  fill: "#2666ef"
})), React.createElement("g", {
  clipPath: "url(#logo_svg__c)"
}, React.createElement("path", {
  d: "M364.342 288.424h27.242V73.58h-27.242z",
  fill: "#2666ef"
})), React.createElement("g", {
  clipPath: "url(#logo_svg__d)"
}, React.createElement("path", {
  d: "M424.721 288.424h27.242V73.58h-27.242z",
  fill: "#2666ef"
})), React.createElement("g", null, React.createElement("g", {
  clipPath: "url(#logo_svg__e)"
}, React.createElement("path", {
  d: "M501.953 166.258h103.912c-2.247 30.612-19.098 49.99-49.99 49.99-30.893 0-50.552-18.816-53.922-49.99m52.799-96.891c-53.36 0-80.04 31.455-80.04 81.445v3.37c0 16.85 3.369 31.455 9.829 44.373 13.2 25.276 37.914 39.88 71.053 39.88 17.693 0 32.297-3.652 43.53-11.234 23.029-15.166 33.982-40.722 33.982-69.65v-12.918H501.672c1.966-33.14 21.064-52.236 54.203-52.236 23.31 0 39.598 10.11 45.496 28.926h29.489c-9.268-33.138-36.23-51.956-76.108-51.956",
  fill: "#2666ef"
}))), React.createElement("g", null, React.createElement("g", {
  clipPath: "url(#logo_svg__f)"
}, React.createElement("path", {
  d: "M766.138 181.985v.562c0 8.987-2.247 16.007-5.898 21.343-7.583 10.672-20.501 14.324-35.667 14.324-2.527 0-4.212-.282-6.178-.562-23.03-1.404-37.914-14.042-37.633-35.386v-.562c0-21.906 14.885-33.982 41.565-33.982 28.645 0 43.81 12.357 43.81 34.263m12.358-129.749c0 14.042-9.83 23.31-37.352 23.31h-29.77C685.818 73.58 673.46 63.19 673.46 47.743v-.28c0-14.043 12.919-24.715 43.81-24.715h5.057c40.16 0 56.168 11.795 56.168 29.488M675.988 4.774c-21.344 6.46-29.208 18.255-29.208 34.543 0 17.693 10.953 30.612 36.229 37.071-20.782 3.09-30.331 13.481-30.331 28.646 0 15.727 12.076 26.961 35.667 31.174-23.31 6.74-34.824 21.906-34.824 46.34v.28c0 29.768 20.782 48.585 58.134 52.236 3.089.843 10.672 1.123 14.322 1.123 10.672.843 17.974 1.966 23.31 3.932 10.672 4.494 12.919 12.357 12.919 25.838v3.09h30.893v-4.776c0-7.582-1.405-13.76-3.932-18.535-5.336-9.829-17.974-14.323-41.565-15.165h.562c9.83-1.124 17.974-4.213 24.714-8.706 13.48-9.269 20.502-23.029 20.502-38.476v-1.123c0-33.982-26.4-54.764-71.053-54.764h-5.336c-10.953 0-19.378-.562-24.995-1.966-11.796-2.247-15.166-7.022-15.166-13.48 0-8.988 7.583-13.76 27.804-13.48h37.632c43.25 0 61.505-17.133 61.505-44.936C803.77 21.625 779.338 0 722.046 0h-2.528c-18.535 0-32.858 1.684-43.53 4.774",
  fill: "#2666ef"
}))), React.createElement("g", null, React.createElement("g", {
  clipPath: "url(#logo_svg__g)"
}, React.createElement("path", {
  d: "M835.788 166.258h103.91c-2.246 30.612-19.097 49.99-49.989 49.99-30.893 0-50.552-18.816-53.922-49.99m52.798-96.891c-53.36 0-80.04 31.455-80.04 81.445v3.37c0 16.85 3.37 31.455 9.83 44.373 13.2 25.276 37.913 39.88 71.053 39.88 17.693 0 32.297-3.652 43.53-11.234 23.03-15.166 33.982-40.722 33.982-69.65v-12.918H835.506c1.966-33.14 21.063-52.236 54.203-52.236 23.31 0 39.598 10.11 45.496 28.926h29.488c-9.267-33.138-36.228-51.956-76.108-51.956",
  fill: "#2666ef"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.24 19.95v32.987H168.4l-65.427 84.734h43.907l64.627-84.36V19.95zm100.053 147.214H80.187l-68.094 88.187v31.106h199.414v-34.48H59.32z",
  fill: "#2666ef"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.88 137.67l-22.587 29.494H80.187l22.786-29.493z",
  fill: "#022ece"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 137.671v29.492h80.187l22.786-29.492zM211.506 137.67v29.494h-87.213l22.587-29.493z",
  fill: "#2666ef"
});

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    height: 384.565,
    width: 1289.255
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "21e2d740ef9dd251fa44af3fb800c50c.svg";
export { SvgLogo as ReactComponent };